$("document").ready(function () {
  
});

function showandclose() {
    
  var x = document.getElementById("gooleMap");
  if (x.style.display === "none") {

  var element = document.getElementById("locationList");
  element.classList.remove("col-md-11");
  element.classList.add("col-md-8");
  setTimeout(()=>{                   
    x.style.display = "block";
  }, 300);
 

  } else {
    x.style.display = "none";
    var element = document.getElementById("locationList");
    element.classList.remove("col-md-8");
    element.classList.add("col-md-11");

  } 

}
                      



